var solutionScript = (function () {
    function solutionScript() {
    }
    solutionScript.prototype.GetSolutionList = function () {
        var solutionObject = { id: 0, solutionList: [] };
        if (this.episode == 0)
            solutionObject.id = 30, solutionObject.solutionList = [
                {
                    id: 30001, type: 1, state: 0, name: "A", title: "酒店淡季的客房促销方案", style: { "border-bottom-left-radius:": "0" },
                    d: "1.  时间：2018年X月X日 –X月X日<br/>" +
                        "2.  主题：温馨午夜房，天天特价房，会员充值，VIP打折卡<br/>" +
                        "3.  措施：更新酒店的设施设备和实施新的网约房战略，使客房服务多样化<br/>" +
                        "4.  对象：网约房客户，散客<br/>" +
                        "5.  目的：完善客房软装升级，提升客房创新意识，为客人提供满意的服务<br/>" +
                        "6.  活动内容：午夜房99元/间/晚；特价房108/间/晚；VIP卡可享8.8折；充值卡2000元起充，赠500元消费券<br/>" +
                        "7.  宣传推广方式：人力推广和媒介推广<br/>" +
                        "8.  预算：软装更新 50万<br/>"
                },
                {
                    id: 30002, type: 2, state: 0, name: "B", title: "与旅行社或出租车公司成为战略伙伴", style: { "margin-left": "0.3rem" },
                    d: "1.  目的：与旅行社、出租车及网络打车平台联盟促销<br/>" +
                        "2.  措施：<br/>" +
                        "  a)  旅行社：将淡季客户份额与旺季客房配额挂钩；在客房与会务厅放置旅行社二维码<br/>" +
                        "  b)  出租车：设计酒店明信片放在出租车上；住客可优先打车或租车<br/>" +
                        "  c)  网络打车：平台上投放酒店广告；在前台和会务厅放置二维码，新客打车第一单酒店可提成<br/>" +
                        "3.  优势：多渠道拓展客户源，同时与供应商保持良性互利关系；成本较低，前期花费少<br/>" +
                        "4.  预算：15万<br/>"
                },
                {
                    id: 30003, type: 3, state: 0, name: "C", title: "酒店全员促销方案", style: { "margin-left": "0.3rem" },
                    d: "1.  目的：调动员工积极性，共创酒店淡季业绩<br/>" +
                        "2.  措施：<br/>" +
                        "  a)  员工介绍散客住宿，以前厅登记的房间数为准，可抽成房费的3%<br/>" +
                        "  b)  员工介绍团队住宿，5间（含）以上，可抽成房费的5%<br/>" +
                        "  c)  每个月前三名获得“推荐之星”，酒店晨会时公开表扬<br/>" +
                        "  d)  一个季度累积获得2次（含）以上“推荐之星”，个人获得额外奖金，所在团队可获赠一次团建<br/>" +
                        "3.  建立客户数据库：收集客户反馈信息，调查近期主要客源，不定期进行客户回访<br/>" +
                        "4.  预算：5万<br/>"
                },
                {
                    id: 30004, type: 4, state: 0, name: "D", title: "酒店淡季套餐与积分兑换的更新方案", style: { "margin-left": "0.3rem" },
                    d: "1. 目的：帮助酒店在淡季能够吸引更多客户<br/>" +
                        "2. 措施：<br/>" +
                        " a) 推出特色套餐：如养生系列、修身系列、美体系列等<br/>" +
                        " b) 每个系列建议以3-4天的短周期为主，包含双休日，可吸引更多工薪阶层<br/>" +
                        " c) 套餐初始和结束时，由会务人员各推荐一次会员卡优惠信息<br/>" +
                        " d) 会员可获得积分，办卡当天所有消费得双倍积分<br/>" +
                        " e) 积分兑奖，小宗奖品可即时领取，大宗奖品3天内免邮送达<br/>" +
                        " f) 会员还可在生日当天获得神秘礼品<br/>"
                },
                {
                    id: 30005, type: 5, state: 0, name: "E", title: "商务会议淡季推广方案", style: { "margin-left": "0.25rem" },
                    d: "1．  目的：提升商务会议（酒店重要收入组成部分）营收<br/>" +
                        "2. 措施：<br/>" +
                        " a) 精准定位：在各商区、写字楼分发宣传页<br/>" +
                        " b) 动员全员参与：鼓励员工转发官方推广信息<br/>" +
                        " c) 优化流程：精简餐饮、前厅、会议、营销等各部的沟通流程，确保第一时间精确传达客户要求<br/>" +
                        " d) 会议服务跟进：设置客户满意度调研，定期发送酒店优惠信息，刺激二次消费<br/>" +
                        " e) 激励政策：会议满意度达95%（含）以上，服务团队可获赠一次团建<br/>" +
                        "3．预算：5万<br/>"
                }
            ];
        else if (this.episode == 1)
            solutionObject.id = 31, solutionObject.solutionList = [
                {
                    id: 30011, type: 1, state: 0, name: "A", title: "引进智能服务机器人，开发酒店APP系统", style: { "border-bottom-left-radius": 0, "width": "1.0rem" },
                    d: "1. 目的：通过引进机器人提升服务质量和效率，利用APP打造智能化酒店生态<br/>" +
                        "2. 措施<br/>" +
                        "  a) 前厅加入机器人服务员，协助订房、引路、咨询等<br/>" +
                        "  b) 开发酒店APP系统，加入订房、消费、购物功能，同时增加定制客房服务，如在预定时就可以设定客房摆件、床品、迷你吧台品种等<br/>" +
                        "  c) 智能化操作，顾客通过手机终端，就能远程控制酒店房间设施设备的运作，如事先打开空调、电视机、浴室水温调控等<br/>" +
                        "3. 优势：目前市场上能提供此类服务的竞争对手较少，同质化竞争不激烈，能吸引客户的兴趣<br/>" +
                        "4. 预算：APP开发+机器人引进 200万<br/>"
                },
                {
                    id: 30012, type: 2, state: 0, name: "B", title: "建立客户数据库，塑造酒店“走心”服务的口碑", style: { "margin-left": "0.1rem", "width": "1.0rem" },
                    d: "1.  目的：分析客户数据，描绘“顾客画像”，打造“超满意度”服务体系<br/>" +
                        "2.  措施：<br/>" +
                        "  a)  服务程序细节化：通过培训规范服务程序，充分预演、改善操作程序中的每一个细小环节，保证顾客舒适体验<br/>" +
                        "  b)  服务响应速度化：及时响应顾客要求，树立“5分钟响应”机制，即必须在5分钟内回应客户，哪怕暂时无法完全解决，也需给出临时方案<br/>" +
                        "  c)  服务态度一致性：保证对所有顾客的服务质量的一致性，提升顾客对酒店品牌的信任以及与酒店的长期联结<br/>" +
                        "3.  优势：利用大数据分析，提供个性化服务<br/>" +
                        "4.  预算：50万<br/>"
                },
                {
                    id: 30013, type: 3, state: 0, name: "C", title: "打造健康和文化为核心的主题型酒店", style: { "margin-left": "0.1rem", "width": "1.0rem" },
                    d: "1.  目的：以周围城市的文化氛围和健康养生为核心，营造更舒适、新颖的酒店环境，提升入住体验<br/>" +
                        "2.  措施：<br/>" +
                        "  a)  推出不同养生套餐服务，将宣传页放在每间客房的酒店介绍手册中<br/>" +
                        "  b)  文化风情客房设计，通过不同的软装布置，展现相应主题<br/>" +
                        "  c)  酒店服务升级，贴合文化氛围，以A市著名人文历史为基础，培训特色的文化礼节和手势，应用于客服场景<br/>" +
                        "  d)  提升服务人员文化素养，每周2次文化课，能熟练解答人文典故和景观的相关问题<br/>" +
                        "3.  符合当下都市白领和年轻一族的需求，并融合当地文化内涵，升级酒店服务特色<br/>" +
                        "4.  预算：180万<br/>"
                },
                {
                    id: 30014, type: 4, state: 0, name: "D", title: "加强酒店安全服务管理，保护客户私人信息", style: { "margin-left": "0.1rem", "width": "1.0rem" },
                    d: "1. 目的：做好安全服务管理，打造360°安心私人度假空间<br/>" +
                        "2. 措施：<br/>" +
                        " a) 硬件设施设备：安装监控系统、安全报警系统、自动灭火装置、通讯系统、电子门锁系统及其他智能安保设施设备<br/>" +
                        " b) 相关规章制度：建立安全防范预案，做好各种突发事件应对准备，及时排除不安全因素<br/>" +
                        " c) 服务人员素质：加强对服务人员的安全性教育，树立“酒店安全人人有责”的观念，并且严格遵守不泄露客户私人信息的准则<br/>" +
                        "3.  优势：人们越来越重视个人隐私和人身安全，酒店的安全服务做得标准能让注重这方面的顾客更倾向于选择入住<br/>" +
                        "4.  预算：60万<br/>"
                },
                {
                    id: 30015, type: 5, state: 0, name: "E", title: "重塑空间概念，升级酒店大堂服务功能", style: { "margin-left": "0.1rem", "width": "1.0rem" },
                    d: "1．  目的：旨在以年轻活力、轻松便捷、自由舒适的环境和氛围给予年轻一代的消费者更好的入住体验<br/>" +
                        "2. 措施：<br/>" +
                        " a) 大堂新增休闲区 – 将原本的沙发区变为富有设计感的圆型矮凳，能让更多的顾客增进交流机会<br/>" +
                        " b) 大堂开放购物区 – 24h便利购，可全天消费，分为品牌商品和日用品两类<br/>" +
                        " c) 简易健身器材借用区 – 青春加油站，用心满足顾客旅途中的健身需求，不用昂贵的健身费，只需扫码即可将简易器材借回客房进行锻炼<br/>" +
                        "3．优势：对酒店大堂服务功能的全新升级，使其更加符合现在年轻人的消费需求<br/>" +
                        "4．预算：100万<br/>"
                },
                {
                    id: 30016, type: 6, state: 0, name: "F", title: "新创餐饮品牌，吸引更多客户", style: { "margin-left": "0.1rem", "width": "1.0rem" },
                    d: "1．  目的：作为国际性度假酒店，满足所有宾客的用餐需求<br/>" +
                        "2. 措施：<br/>" +
                        " a) 改造酒店负一楼的全日餐厅，打通室内和室外，室外做成阳光房，以中式庭院和和地中海风情为主题<br/>" +
                        " b) 新增A市首家配有儿童游乐区的星级酒店自助餐厅，提供超大的区域供儿童玩耍，成人可舒心用餐，吸引周边上班族进行周末度假<br/>" +
                        " c) 打造海鲜池，既可以供客人观赏，同时满足吃货们的要求，现点现做<br/>" +
                        "3．优势：通过升级酒店的餐饮服务，将餐饮作为酒店特色服务，树立口碑效应<br/>" +
                        "4．预算：120万<br/>"
                }
            ];
        else if (this.episode == 2)
            solutionObject.id = 32, solutionObject.solutionList = [
                {
                    id: 30021, type: 1, state: 0, name: "A", title: "升职涨薪", style: { "border-bottom-left-radius:": "0" },
                    d: "目的：暂时稳住黎启，确保促销季人手足够<br/>" +
                        "具体做法<br/>" +
                        "1. 将黎启从“初级会务专员”（L9）提升为“资深会务专员”(L7)<br/>" +
                        "2. 涨薪方案（下个月起生效）<br/>" +
                        "  a) 绩效超常：涨幅25%<br/>" +
                        "  b) 绩效优秀：涨幅15%<br/>" +
                        "  c) 绩效良好：涨幅10%<br/>" +
                        "  d) 绩效待改进：涨幅0%<br/>" +
                        "  e) 绩效不佳：涨幅0%<br/>"
                },
                {
                    id: 30022, type: 2, state: 0, name: "B", title: "批准离职", style: { "margin-left": "0.3rem" },
                    d: "目的：处理问题员工，避免影响团队情绪，并且尽可能保证促销季的工作不受影响<br/>" +
                        "具体做法：<br/>" +
                        "1. 跟黎启做离职谈话，确认离职日期<br/>" +
                        "2. 工作交接处理<br/>" +
                        "3. 尽快启动招聘流程，争取新人两周内到岗<br/>" +
                        "备注：会产生招聘费用<br/><br/>"
                },
                {
                    id: 30023, type: 3, state: 0, name: "C", title: "沟通和辅导", style: { "margin-left": "0.3rem" },
                    d: "目的：提升黎启的绩效<br/><br/>" +
                        "具体做法：<br/>" +
                        "1. 找黎启谈话，希望他能留下<br/>" +
                        "2. 了解黎启最近状况频出，到底是什么原因造成的<br/>" +
                        "3. 帮助黎启解决工作中面临的压力和困难<br/>" +
                        "4. 帮助黎启提升个人绩效，并激发他的工作积极性<br/><br/>"
                },
                {
                    id: 30024, type: 4, state: 0, name: "D", title: "员工激励机制", style: { "margin-left": "0.3rem" },
                    d: "目的：激发员工积极性，提升整个团队在促销季的战斗力<br/><br/>" +
                        "具体做法：<br/>" +
                        " a) 鼓励多劳多得：在完成原有指标的基础上，每超额完成15%，季度奖金提升8%<br/>" +
                        " b) 推荐客户有奖：鼓励员工推荐销售线索，根据成交额给到抽成<br/>" +
                        " c) 评选优秀员工：每月评选优秀员工，入选员工会有绩效补贴<br/><br/>" +
                        "备注：预算约5万/月<br/><br/>"
                },
                {
                    id: 30025, type: 5, state: 0, name: "E", title: "协议约束", style: { "margin-left": "0.25rem" },
                    d: "来自HR提醒<br/><br/>" +
                        "“黎启签过培训协议，距服务期结束还有四个月。原则上他现在要走，酒店有权要他支付违约金。”<br/><br/>" +
                        "具体做法：约谈黎启，告诉他如果现在要离职，必须支付高额违约金<br/><br/>"
                }
            ];
        return solutionObject;
    };
    solutionScript.prototype.QuestionHotelSolutionTrueOrFalse = function () {
        var result = {};
        if (this.episode == 0) {
            result = {
                id: 33,
                title: "评估方案时需要关注决策的标准，下列哪些标准是必须要符合的，请判断:",
                type: "判断题",
                sub: 3,
                options: [
                    "控制成本，不要有太多花销",
                    "达到今年自己和整个团队的KPI指标",
                    "团队士气保持高位，激励措施到位",
                    "市场的反馈良好",
                    "团队及跨部门伙伴对方案的接受度高",
                    "方案的执行较为容易，实施计划不复杂"
                ]
            };
        }
        else if (this.episode == 1) {
            result = {
                id: 34,
                title: "评估方案时需要关注决策的标准，下列哪些标准是必须要符合的，请判断:",
                type: "判断题",
                sub: 3,
                options: [
                    "控制成本，不要有太多花销",
                    "客户满意度在下一个月上升至95%",
                    "市场的反馈良好",
                    "各部门配合与响应速度需超过行业平均标准",
                    "团队及跨部门伙伴对方案的接受度高",
                    "方案的执行较为容易，实施计划不复杂"
                ]
            };
        }
        else {
            result = {
                id: 35,
                title: "评估方案时需要关注决策的标准，下列哪些标准是必须要符合的，请判断:",
                type: "判断题",
                sub: 3,
                options: [
                    "控制成本，不要有太多花销",
                    "团队士气保持高位，激励措施到位",
                    "在一个月内看到行动上的改变，保证个人绩效达标",
                    "保证自己团队的稳定性，使提供的服务和销售质量不受到影响",
                    "处理过程要保证公平公正，兼顾对团队其他成员的影响"
                ]
            };
        }
        return result;
    };
    solutionScript.prototype.QuestionHotelSolutionSingleChoice = function () {
        var result = {};
        if (this.episode == 0) {
            result = {
                id: 36,
                title: "根据标准，确定最佳方案:",
                type: "单选题",
                sub: 1,
                options: [
                    "A. 酒店淡季的客房促销方案",
                    "B. 与旅行社或出租车公司成为战略伙伴",
                    "C. 酒店全员促销方案",
                    "D. 酒店淡季套餐与积分兑换的更新方案",
                    "E. 商务会议淡季推广方案"
                ]
            };
        }
        else if (this.episode == 1) {
            result = {
                id: 37,
                title: "根据标准，确定最佳方案:",
                type: "单选题",
                sub: 1,
                options: [
                    "A. 引进智能服务型机器人，开发酒店APP系统",
                    "B. 建立客户数据库，塑造酒店“走心”服务的口碑",
                    "C. 打造健康和文化为核心的主题型酒店",
                    "D. 加强酒店安全服务管理，保护客户私人信息",
                    "E. 重塑空间概念，升级酒店大堂服务功能",
                    "F. 新创餐饮品牌，吸引更多客户"
                ]
            };
        }
        else if (this.episode == 2) {
            result = {
                id: 38,
                title: "根据标准，确定最佳方案:",
                type: "单选题",
                sub: 1,
                options: [
                    "A. 升职涨薪",
                    "B. 批准离职",
                    "C. 沟通与辅导",
                    "D. 员工激励机制",
                    "E. 协议约束"
                ]
            };
        }
        return result;
    };
    solutionScript.prototype.GotoLastQuestion = function () {
        var result = {};
        //酒店
        if (this.episode == 0) {
            result = {
                id: 39,
                title: "你已经把最新的淡季促销方案制作出来了，接下来要怎么做？",
                type: "单选题",
                sub: 1,
                options: [
                    "终于赶在限期之前把报告赶出来了，立马发给总经理过目",
                    "暂时先等等吧，让我自己再检查一遍，把数据上可能会出错的地方再审核下",
                    "要不要让伙伴们再看一眼呢？或许会有更好的改进建议",
                    "让不同的伙伴看一下相关事项，更好地协助方案实施"
                ]
            };
        }
        else if (this.episode == 1) {
            result = {
                id: 40,
                title: "你已经把提升酒店服务质量的方案制作出来了，接下来怎么做？",
                type: "单选题",
                sub: 1,
                options: [
                    "终于赶在限期之前把报告赶出来了，立马发给总经理过目",
                    "暂时先等等吧，让我自己再检查一遍，把数据上可能会出错的地方再审核下",
                    "要不要让伙伴们再看一眼呢？或许会有更好的改进建议",
                    "让不同的伙伴看一下相关事项，更好地协助方案实施"
                ]
            };
        }
        else if (this.episode == 2) {
            result = {
                id: 41,
                title: "你已经把最新的淡季促销方案制作出来了，接下来要怎么做？",
                type: "单选题",
                sub: 1,
                options: [
                    "哎，黎启的事儿老板一直很关心，赶快把决定告诉秦总吧！",
                    "暂时先等等吧，让我自己再看一遍，把可能会出错的地方再检查一下。",
                    "要不要让伙伴们再看一眼呢？或许会有更好的改进建议",
                    "让不同的伙伴看一下相关事项，更好地协助方案实施"
                ]
            };
        }
        return result;
    };
    solutionScript.prototype.GetHotelSolutionTip = function (n) {
        var result = "";
        if (this.episode == 0)
            switch (n) {
                case 0:
                    result = "选择A方案，你的考量是什么？<br/><br/>" +
                        "A方案的想法不错，但是它受制于两个因素：第一，软装更新的预算不够。第二，网约房的合同能否顺利续签。<br/><br/>" +
                        "综合考虑，A方案并不是最佳选择。<br/><br/>";
                    break;
                case 1:
                    result = "选择B方案，你的考量是什么？<br/><br/>" +
                        "B方案在成本上尚在可控范围，同时对于提升酒店的淡季销售额也会有一定促进作用。但从执行的难易角度来看，它略有缺失，毕竟战略性结盟没有那么简单，周边的其他酒店也抱有同样的想法呢，这场硬仗不好打哦。<br/><br/>" +
                        "综合考虑，B方案并不是最佳选择。<br/><br/>";
                    break;
                case 2:
                    result = "恭喜你，选择了C方案！<br/><br/>" +
                        "C方案在关键的决策准则上都能打出高分，在成本、对销量的提升度、跨部门的接受度、易执行性方面都有较好的考量。<br/><br/>" +
                        "综合考虑，C方案是较为适合DC Mak酒店的淡季促销方案。<br/><br/>";
                    break;
                case 3:
                    result = "选择D方案，你的考量是什么？<br/><br/>" +
                        "D方案在成本上略高了一些，跨部门的接受度似乎也不太高，毕竟积分兑奖要做到即时兑换并不是靠一己之力能完成的。实际执行时，但凡有一环掉了链子，就达不到理想的结果。" +
                        "综合考虑，D方案并不是最佳选择。<br/><br/>";
                    break;
                case 4:
                    result = "选择E方案，你的考量是什么？<br/><br/>" +
                        "我们可能会在E方案和C方案中纠结，因为两个方案看上去都不错。但是商务会议的淡季推广可能会有风险，年中的时段是否能够吸引足够的客源，以及流程的优化和磨合是否能在短时内顺利完成。" +
                        "综合考虑，E方案并不是最佳选择。<br/><br/>";
                    break;
                default:
                    result = "《未知选项》";
                    break;
            }
        else if (this.episode == 1)
            switch (n) {
                case 0:
                    result = "选择A方案，你的考量是什么？<br/><br/>" +
                        "A方案胜在新颖性和智能化，伙伴们对它的好感度都挺高，但方案的短板也十分明显。一来，成本过高。二来，智能化设备带来的可能不是便捷而是麻烦，对提升满意度并不一定是助力呢？<br/><br/>" +
                        "综合考虑，A方案并不是最佳选择 <br/><br/>";
                    break;
                case 1:
                    result = "恭喜你，选择了B方案！<br/><br/>" +
                        "B方案在成本、提升满意度、部门接受度等评估标准上得分都比较高。而且作为酒店，提升服务体系要从服务的本质上着手，用户更多的还是希望得到“用心”和“细致”的关怀。<br/><br/>" +
                        "所以综合考虑，B方案是这几个方案中最适合的。<br/><br/>";
                    break;
                case 2:
                    result = "选择C方案，你的考量是什么？<br/><br/>" +
                        "C方案以健康和文化为核心，能将酒店的优势较好地展现在客户的面前，同时也符合了当下的流行趋势。但是该方案的成本略微高，而且工期较长。<br/><br/>" +
                        "所以综合考虑，C方案并不是最佳选择！<br/><br/>";
                    break;
                case 3:
                    result = "选择D方案，你的考量是什么？<br/><br/>" +
                        "加强酒店安全服务管理的确很重要，保护客户的人身安全和私人信息是服务行业的头等大事。但安全性是服务的基础，有了安全性并不代表服务质量的提升。<br/><br/>" +
                        "综合考虑，D方案并不是最佳选择。<br/><br/>";
                    break;
                case 4:
                    result = "选择E方案，你的考量是什么？<br/><br/>" +
                        "酒店的空间改造比较符合当下年轻人的需求，伙伴们似乎对它的好感度也不低，但成本是决策的核心标准之一，方案在具体实施上也不如预想的简单。" +
                        "综合考虑，E方案并不是最佳选择。<br/><br/>";
                    break;
                case 5:
                    result = "选择F方案，你的考量是什么？<br/><br/>" +
                        "作为美食爱好者，我也很想选这个选项呢！但是考虑到我们的决策主旨是为了提升酒店的服务质量，让消费者更加满意，光靠美食来诱惑可能力度不够哦。" +
                        "综合考虑，F方案并不是最佳选择。<br/><br/>";
                    break;
                default:
                    result = "《未知选项》";
                    break;
            }
        else if (this.episode == 2)
            switch (n) {
                case 0:
                    result = "选择A方案，你的考量是什么？<br/><br/>" +
                        "升职加薪当然人人喜欢，但作为领导，你还需要考虑该方案是否会对团队其他成员的稳定性造成影响。况且，你确定黎启的问题真的是通过加薪就能够解决的吗？<br/><br/>" +
                        "综合考虑，A方案并不是最佳选择 <br/><br/>";
                    break;
                case 1:
                    result = "选择B方案，你的考量是什么？<br/><br/>" +
                        "虽然员工的表现不如人意，给酒店的促销工作开展造成了额外的麻烦。但是，作为领导，你有了解过该员工平时的表现是否也是如此吗？仓促地做出决定，或许会给接下来的工作安排带来麻烦哦。<br/><br/>" +
                        "综合考虑，B方案并不是最佳选择。<br/><br/>";
                    break;
                case 2:
                    result = "恭喜你，选择了C方案！<br/><br/>" +
                        "当下属出现职业瓶颈时，最好的方式是先和他沟通。充分了解前因后果之后，通过有效辅导，改善他的工作表现。<br/><br/>" +
                        "同部门同事的认可说明黎启是有一定能力的。现在他最需要的是你来帮助他解决职业上遇到的问题，克服障碍，相信他可以变得更好！<br/><br/>";
                    break;
                case 3:
                    result = "选择D方案，你的考量是什么？<br/><br/>" +
                        "激励方案对于增强团队士气有较大的帮助。但该方案可能在成本上略高，而且不能从根本上解决黎启的问题。<br/><br/>" +
                        "综合考虑，D方案并不是最佳选择。<br/><br/>";
                    break;
                case 4:
                    result = "选择E方案，你的考量是什么？<br/><br/>" +
                        "用协议约束的方式来让员工不敢离职，这样的做法虽然能在短期内解决人手不足的问题，但并不能让员工长期稳定下来。甚至可能会造成反向效果，让员工加速离职的进程。" +
                        "综合考虑，E方案并不是最佳选择。<br/><br/>";
                    break;
                default:
                    result = "《未知选项》";
                    break;
            }
        return result;
    };
    solutionScript.prototype.GetExtraQuestion = function (qid) {
        var result = { id: 0, title: "" };
        if (this.episode == 0)
            switch (qid) {
                case 0:
                    result = { id: 61, title: "酒店全员促销方案的预算审批" };
                    break;
                case 61:
                    result = { id: 62, title: "前厅服务人员相关标准流程的重新制定细节" };
                    break;
                case 62:
                    result = { id: 63, title: "调动员工积极性，优化激励政策" };
                    break;
                case 63:
                    result = { id: 64, title: "淡季宣传标语以及宣传手册，网络投放的渠道商谈等" };
                    break;
                case 64:
                    result = { id: 65, title: "个性化住房的软装布置，房内细节摆设以及小部件设计等" };
                    break;
                case 65:
                    result = { id: 66, title: "建立客户数据库，讨论客户信息的利用方法" };
                    break;
                case 66:
                    result = { id: 67, title: "制定优化会务流程的长期计划" };
                    break;
            }
        else if (this.episode == 1)
            switch (qid) {
                case 0:
                    result = { id: 70, title: "酒店服务升级方案的预算审批" };
                    break;
                case 70:
                    result = { id: 71, title: "制定前台服务人员的服务礼节准则，提升人员素质" };
                    break;
                case 71:
                    result = { id: 72, title: "培训规范化，充分预演服务程序，制定激励政策，辅助推行“5分钟响应”机制" };
                    break;
                case 72:
                    result = { id: 73, title: "酒店服务升级后的宣传标语、推广活动等" };
                    break;
                case 73:
                    result = { id: 74, title: "酒店大堂的空间重置，更加个性化的设计及装饰" };
                    break;
                case 74:
                    result = { id: 75, title: "建立大数据分析库，描绘“顾客画像”，提供特色服务" };
                    break;
                case 75:
                    result = { id: 76, title: "制定会务服务细则，及时响应客户商务会议中的任何需求" };
                    break;
            }
        else if (this.episode == 2)
            switch (qid) {
                case 0:
                    result = { id: 80, title: "方案中可能会涉及到的预算审批" };
                    break;
                case 80:
                    result = { id: 81, title: "获得上一季度黎启的工作小结以及主管评价" };
                    break;
                case 81:
                    result = { id: 82, title: "了解黎启工作岗位的具体职责，以及近期内需要负责的关键事项" };
                    break;
                case 82:
                    result = { id: 83, title: "开展前台与会务部门的交叉培训，在忙碌期进行人手借调" };
                    break;
                case 83:
                    result = { id: 84, title: "下下周VVIP客户团的接待，贵宾厅的设备调试与预防性维修" };
                    break;
            }
        return result;
    };
    solutionScript.prototype.GetSolutionDialogueScript = function (type) {
        var diglogues = [{ count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }];
        if (this.episode == 0) {
            switch (type) {
                case 1:
                    diglogues[0].count = 0;
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 31001, title: "网约房的事情能不能解决，今年的特价房活动…", state: 0, data: [
                                    "对了，网约房的事情你们什么时候处理？如果这个问题没有解决的话，今年淡季还搞什么特价房的促销活动啊！"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 31004, title: "我把酒店软装更新的计划和总经理提了，他说…", state: 0, data: [
                                    "唉……我把酒店软装更新的计划和秦总提了，他的态度似乎不是很支持，觉得要花50万有点多了，你说怎么办？"
                                ]
                            }];
                    break;
                case 2:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 32000, title: "方案我看过了，想法不错…", state: 0, data: [
                                    "嗯，方案我已经看过了，想法是不错，虽然也需要资金投入，但还在可控范围内。",
                                    "不过，战略性结盟没有想象得那么容易，周围的几家旅行社都处于观望状态，出租车公司这边我可以帮你先去探探路，有几家的老总和我比较熟，姑且试试看吧。"
                                ]
                            }];
                    diglogues[1].count = 0;
                    diglogues[2].count = 0;
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 32003, title: "方案我喜欢，互利互惠，现在不是都在讲…", state: 0, data: [
                                    "领导，这个方案我很喜欢啊，互利互惠，现在不是都在讲要打造共赢的生态圈嘛，反正我和我的团队会全力支持的。"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
                case 3:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 33000, title: "我觉得挺不错的，如果能够调动全体员工的积极性…", state: 0, data: [
                                    "这个方案我觉得也挺不错的，如果能调动全体员工的积极性，酒店上下拧成一股绳，不怕销量上不去。"
                                ]
                            }];
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 33001, title: "对于客户回访的想法我很有兴趣，如果…", state: 0, data: [
                                    "你这个方案里要进行客户回访是吗？这块的数据我有兴趣，如果想执行的话，我团队上可以出人帮忙一起来做。"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 0;
                    diglogues[4].count = 0;
                    break;
                case 4:
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 34001, title: "你提的这个方案真是打动我心…", state: 0, data: [
                                    "你提的这个方案真是打动我心，要做就做和别人不一样的，这样才能把我们的品牌打出来！"
                                ]
                            }];
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 34002, title: "小礼品要做到即时，客户会来前厅询问，但是…", state: 0, data: [
                                    "对了，上次高经理和我说小礼品要做到即时兑换。一般来说，客户都是直接到前厅来询问，但这块是需要各部门配合的，如果货仓没备货，我们也变不出来啊。"
                                ]
                            }];
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 34004, title: "促销方案听上去很吸引人，对于我们工程部来说…", state: 0, data: [
                                    "促销方案里的酒店活动听上去很吸引人，名字也起得好听，谁想的？",
                                    "不过对我们工程部来说，要帮你们搞定所有设施设备不出差错，唔……让我想想，方法也是有的，就是我们要忙起来啦，哈哈！"
                                ]
                            }];
                    break;
                case 5:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 35000, title: "想重点关注会务方面，我们酒店的确有一定优势…", state: 0, data: [
                                    "我理解你想重点关注会务这块，我们酒店的确在商务团队接待上有一定优势，不过我有点担心能否在年中找到大量的商务需求。",
                                    "看到你这么有信心，我也放心啦，加油干！遇到问题的话，我随时可以做大家的后盾！"
                                ]
                            }];
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 35002, title: "商务会议的推广方案，我很支持的，毕竟…", state: 0, data: [
                                    "关于商务会议的推广方案，我很支持啊，立娜姐毕竟是这里的老员工，对酒店的卖点抓得很准。"
                                ]
                            }];
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 35003, title: "谢谢领导采纳了我的想法，其实我有和其他伙伴聊过…", state: 0, data: [
                                    "谢谢领导采纳我的想法，我其实也和餐饮、前厅、营销等部门的伙伴们聊过，他们也支持优化现在的沟通流程。但执行细节上还需探讨，毕竟之前的合作流程已经比较固化了，改动还需要磨合一阵子。"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
            }
        }
        else if (this.episode == 1) {
            switch (type) {
                case 1:
                    diglogues[0].count = 0;
                    diglogues[1].count = 0;
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 41002, title: "这个方案还真是蛮有新意的…", state: 0, data: [
                                    "【星星眼】智能机器人和App的方案很有意思，可以节省掉很多前台的工作，另外也体现出酒店智能化。"
                                ]
                            }];
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 41004, title: "你听说了没？XX酒店的智能机器人的事儿…", state: 0, data: [
                                    "唉，你听说没？XX酒店的机器人管家出事了，把一个VIP客户的重要文件给损坏了。据说这个客户还是记者，立马把那家酒店的问题曝光了。",
                                    "刚路过总经理办公室，秦总还叫住我讨论呢，说机器人毕竟不如人来得灵活变通。他觉得APP还不错，但机器人么，可能要再考虑一下。"
                                ]
                            }];
                    break;
                case 2:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 42000, title: "情感消费的时代要重视消费者的内心充实度…", state: 0, data: [
                                    "现在是情感消费时代，消费者更重视心灵的充实而非物质上的噱头。",
                                    "我们要以酒店的价值观为基础，把打造极致休闲体验的理念放在首位，全方位设计贴心服务。预算这边我还是有的，不用太束手束脚。",
                                    "个性化的服务需要从“细节”入手，员工都需要具备这样的意识，大数据是辅助手段。"
                                ]
                            }];
                    diglogues[1].count = 0;
                    diglogues[2].count = 0;
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 42003, title: "想法赞同，但是高素质的人员恐怕不好培养…", state: 0, data: [
                                    "我挺喜欢这个方案的，对于酒店来说，服务的软实力是重要的考核指标，只是我觉得培训一批高素质的服务人员需要的时间不算短呢。"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
                case 3:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 43000, title: "构建健康和人文主题的想法不错，顾客会愿意看到一家不同风格的酒店…", state: 0, data: [
                                    "我觉得构建健康和人文主题是个好想法，本身我们酒店所在位置就有较为良好的自然环境和浓厚的文化底蕴，把这个应用于酒店服务的特色会是不错的升级体验。",
                                    "你还记得酒店的价值观吗？将打造极致休闲体验的理念放在首位，全方位设计有特色的服务，预算方面只要合理，我还是会和大老板争取一下的。"
                                ]
                            }];
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 43001, title: "从市场部的眼光来说，当然是这个方案最有亮点…", state: 0, data: [
                                    "从市场部的视角来说，当然是这个方案最有亮点，因为它比较容易包装。",
                                    "你想想，健康养生、人文底蕴，这两个主题正好能切中现代人的兴趣点，如果能够做好，我个人觉得会很有意思。"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 43004, title: "我觉得用人文主题搭配健康养生的方案不错…", state: 0, data: [
                                    "我好喜欢酒店用人文主题搭配健康养生的方案，这样我们就与别家酒店那种千篇一律的流水线式服务区分开了。",
                                    "而且不论是上了年纪的还是年轻人都会被吸引，就是酒店客房的软装改造，我估计需要一点时间，工期会有点久，你要做好心理准备哦。"
                                ]
                            }];
                    break;
                case 4:
                    diglogues[0].count = 0;
                    diglogues[1].count = 0;
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 44002, title: "安全服务是非常重要的…", state: 0, data: [
                                    "领导，我同意您的想法，酒店的安全服务是非常重要的，最近报道的一起案件，太骇人听闻了，难怪酒店协会对我们提出了这样的要求。"
                                ]
                            }];
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 44003, title: "曾经酒店有发生过这样的事情，安全性不容忽视…", state: 0, data: [
                                    "嗯，领导，您提出的这个方案我是大力支持的，安全性对于会务来说真是深有体会。曾经有客户在会议厅遗失过物件，虽是虚惊一场，但也对满意度造成了影响。",
                                    "这种事情做好了不见得会提升客户满意度，一旦出事，就是大量的投诉，是我的心病一桩。"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
                case 5:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 45000, title: "建造共享空间，扩大社交、购物和健身机会…", state: 0, data: [
                                    "唔，你这个方案仔细琢磨一下，我觉得也有可取之处。就拿我自己举例子吧，出去旅游，一天待在酒店里，最怕的就是无聊，没有地方可以去消费和娱乐。",
                                    "我们酒店周围生态环境不错，就是地理位置稍微有点偏，出行不方便，所以在公共区域增加更多的互动交流机会和休闲空间，这个点子不错。"
                                ]
                            }];
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 45001, title: "重塑空间概念这个想法的确不错…", state: 0, data: [
                                    "重塑空间概念这个想法的确不错，既符合当下年轻一代的潮流，又能更好利用酒店大堂空间。",
                                    "我觉得大堂一旦具备了集休闲、购物、健身于一体的区域，将会给我们的酒店带来新的活力。"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 45004, title: "酒店空间的重新设计，这个想法我挺喜欢…", state: 0, data: [
                                    "酒店空间的重新设计，这个想法我挺喜欢的。就是有点担心，一来购物区的成立，对物流和仓储要求挺高，两个环节没匹配好，就容易出岔子。",
                                    "二来，迷你健身这个概念，我之前出国的时候看见过，真正的使用率不高，有可能达不到预先设想的效果。"
                                ]
                            }];
                    break;
                case 6:
                    diglogues[0].count = 0;
                    diglogues[1].count = 0;
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 46002, title: "餐厅具有社交功能，做好餐厅服务，会进一步提升口碑…", state: 0, data: [
                                    "除了前厅，餐厅也是酒店里最重要的社交场所之一，如果能够把餐厅的口碑和服务做好，满足所有宾客的需求，会对酒店口碑提升有很大益处。"
                                ]
                            }];
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 46004, title: "有些知名酒店就是通过打出自己旗下的餐饮品牌来增加口碑效应…", state: 0, data: [
                                    "作为吃货，我当然是举双手双脚赞成这个方案啦！",
                                    "再加上其实有不少酒店就是通过旗下的餐饮品牌来增加口碑，我们的食物也不比他们差，就是缺几个好厨子来料理罢了。"
                                ]
                            }];
                    break;
            }
        }
        else if (this.episode == 2) {
            switch (type) {
                case 1:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 51000, title: "涨薪方案可以考虑…", state: 0, data: [
                                    "涨薪方案可以考虑，但是黎启的表现不足以服众吧？你在选方案的时候还是要考虑一下公平性。"
                                ]
                            }];
                    diglogues[1].count = 0;
                    diglogues[2].count = 0;
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 51004, title: "涨薪这办法是挺好的…", state: 0, data: [
                                    "涨薪这办法是挺好的，但是你确定管用？别一转身拿着你开的工资去跟别家谈条件，你花了精力还留不住人。"
                                ]
                            }];
                    break;
                case 2:
                    diglogues[0].count = 0;
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 52001, title: "和黎启只合作过几次，给不出很多意见…", state: 0, data: [
                                    "我们和黎启只合作过几次，给不出太多意见。我只能说，如果我部门有这样的员工，绝、对、不、能、忍。"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 52003, title: "黎启最近的状态是不太好…", state: 0, data: [
                                    "黎启最近的状态是不太好，但是他之前的表现还是不错的，人聪明、做事也认真，您看我们能不能再给他一次机会？"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
                case 3:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 53000, title: "员工的去留你自己决定…", state: 0, data: [
                                    "我还是那句话，员工的去留你自己决定。不过你有必要去跟他聊聊，了解员工的真实想法很重要。"
                                ]
                            }];
                    diglogues[1].count = 0;
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 53002, title: "之前和黎启无意中聊到，他家里似乎发生了一点事情…", state: 0, data: [
                                    "之前和黎启无意中聊到，他家里似乎发生了一点事情；工作上么，他好像和其他部门的同事有点小矛盾，闹得很不愉快，我觉得领导是该跟黎启谈谈心了。"
                                ]
                            }];
                    diglogues[3].count = 0;
                    diglogues[4].count = 0;
                    break;
                case 4:
                    diglogues[0].count = 1;
                    diglogues[0].List =
                        [{
                                id: 54000, title: "有激励措施当然好…", state: 0, data: [
                                    "有激励措施当然好，不过这些设计的合理性你还是要考虑考虑。",
                                    "另外，五万的预算有点多了，有这个必要吗？"
                                ]
                            }];
                    diglogues[1].count = 1;
                    diglogues[1].List =
                        [{
                                id: 54001, title: "团队激励最关键的就是要公平公正…", state: 0, data: [
                                    "团队激励最关键的就是要公平公正，如果在实施这些措施的时候，确实做得到一碗水端平，那这个方案挺好的。如果黎启真的要走，肯定会影响其他人的士气，你最好提前想想要怎么做工作。"
                                ]
                            }];
                    diglogues[2].count = 0;
                    diglogues[3].count = 1;
                    diglogues[3].List =
                        [{
                                id: 54003, title: "激励方案啊？我先看看…", state: 0, data: [
                                    "激励方案啊？我先看看……领导，这个点子真不错，我们早就应该这么做了！"
                                ]
                            }];
                    diglogues[4].count = 0;
                    break;
                case 5:
                    diglogues[0].count = 0;
                    diglogues[1].count = 0;
                    diglogues[2].count = 1;
                    diglogues[2].List =
                        [{
                                id: 55002, title: "呃，违约金什么的，好像有点不近人情吧…", state: 0, data: [
                                    "呃，违约金什么的，好像有点不近人情吧……不如和黎启商量商量，就算要走，也等我们找到新人再走，我觉得他会答应的。"
                                ]
                            }];
                    diglogues[3].count = 0;
                    diglogues[4].count = 1;
                    diglogues[4].List =
                        [{
                                id: 55004, title: "原来还有培训协议这一招，那你还担心什么…", state: 0, data: [
                                    "原来还有培训协议这一招，那你还担心什么？违约金什么的倒也算了，但至少能让他别在团队最忙的时候离开。"
                                ]
                            }];
                    break;
            }
        }
        return diglogues;
    };
    solutionScript.prototype.GetHelpStep1_DialogueScript = function () {
        var diglogues = [{ count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }];
        if (this.episode == 0) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 60000, title: "你问我比较看重什么，当然是…", state: 0, data: [
                            "你问我比较看重什么？身为酒店总经理，我更关心方案的成本是否在可控范围内？方案是否比较容易推进？酒店的业绩能否达到目标？"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 60001, title: "一个方案要成功，首先得让所有人都接受，毕竟…", state: 0, data: [
                            "我觉得一个方案要成功，首先得让所有人都接受，毕竟酒店是高度协作的行业，有一环掉了链子都不行！",
                            "还有啊，作为市场营销，方案在市场上的反馈和口碑也是至关重要。"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 60002, title: "整体团队要能全心全意向共同目标前进…", state: 0, data: [
                            "唔，我想整个团队能不能全心全意向着共同目标前进，大家的士气能不能保持在高位，这对我来说是要考虑的重点。",
                            "当然，业绩能不能达标，我觉得也很重要！"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 60003, title: "顾好每一位成员的心情是我的责任…", state: 0, data: [
                            "身为团队负责人，我会顾好每一位成员的心情。另外我们部门其实和其他部门的关联性比较高，所以得到其他人的支持也是必要的。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 60004, title: "做工程的最关心的就是…", state: 0, data: [
                            "成本是最重要的，其次就是绩效了，反正我做工程的最关心的就是这两样。"
                        ]
                    }];
        }
        else if (this.episode == 1) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 61000, title: "我希望看到酒店服务能切实提升客户满意度…", state: 0, data: [
                            "如果你问我的意见，我会比较希望看到酒店的服务切实地提升了客户满意度，我想我们是有能力把服务做得更加体系化和标准化的。"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 61001, title: "我个人觉得不要把方案做得太复杂了，毕竟…", state: 0, data: [
                            "我个人是觉得不要把方案做得太复杂，毕竟我们酒店也是个老牌子，大动干戈反而不美，到时候新客户没留住，老客户反而也不喜欢了。",
                            "而且得到市场的认可相当重要，做酒店行业，最需要的就是口碑宣传了。"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 61002, title: "领导，我谈谈自己的想法，酒店的服务一定要…", state: 0, data: [
                            "领导，我谈谈自己的想法，酒店的服务一定要超越普通，达到卓越的标准，这样才能吸引顾客长期留住我们酒店。",
                            "我们现在的服务质量只能说是刚刚达到标准水平，但我不满足于只达到标准，突破平凡才能独树一帜。"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 61003, title: "我觉得方案在成本上需要…", state: 0, data: [
                            "唔，我觉得方案在成本上还是要控制一下，虽说以方案为重，预算可以另外争取，但如果投入太多资金，可能会造成周转困难。",
                            "另外呢，我感觉方案不要太复杂，还是需要可操作性高一点。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 61004, title: "服务这种东西，你做得再好，客户不认同也是白瞎…", state: 0, data: [
                            "一定要客户喜欢，服务这种东西，你做得再好，客户不认同也是白瞎，所以要把口碑做好，得到好的反馈。反正我做工程的时候最关心的就是这个。"
                        ]
                    }];
        }
        else if (this.episode == 2) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 62000, title: "处理员工问题最要紧的就是…", state: 0, data: [
                            "处理员工问题最要紧的就是要一碗水端平，别弄得能力好的人越干越累，其他人反而动一动嘴皮子就有甜头尝。",
                            "员工有苦衷、有压力可以理解，但是企业毕竟还是要看个人成果的。"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 62001, title: "黎启我不熟，不能多做评论…", state: 0, data: [
                            "黎启我不熟，不能多做评论。但作为一个看重结果的人，我对下属的要求是同样的错误不允许出现两次。如果你做不到，对不起，我只能说你不适合。"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 62002, title: "我一定是以团队利益为先…", state: 0, data: [
                            "问我的话，我一定是以团队利益为先的。",
                            "黎启这个年轻人有想法、有活力。领导，给他一些时间吧，我相信他会有改变的。"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 62003, title: "领导，黎启的问题要解决…", state: 0, data: [
                            "领导，黎启的问题要解决，但是毕竟马上要到促销季了，VVIP的接待任务工作量又很大，所以，我觉得还是要以业务为重吧。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 62004, title: "我其实…", state: 0, data: [
                            "我其实没什么想法，平时和黎启接触得不多。不过我跟你讲，现在的下属真的不好管，就说我们部门的那谁谁……【挨个点评自己的下属】"
                        ]
                    }];
        }
        return diglogues;
    };
    solutionScript.prototype.GetHelpStep2_DialogueScript = function () {
        var diglogues = [{ count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }, { count: 0, List: [] }];
        if (this.episode == 0) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 70000, title: "几个方案中，我更偏好商务会议推广…", state: 0, data: [
                            "几个方案中，我更偏好酒店全员促销或者是商务会议推广的方案。"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 70001, title: "要我选，当然是酒店套餐活动…", state: 0, data: [
                            "要我选，当然是酒店套餐活动和积分兑奖的方案啦！"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 70002, title: "我支持立娜姐的方案…", state: 0, data: [
                            "我支持立娜姐的方案。"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 70003, title: "我当然是投自己的方案一票…", state: 0, data: [
                            "我当然是投自己的方案一票，另外就是全员促销的方案，我觉得也不错啊。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 70004, title: "我最喜欢的方案就是建立战略性伙伴关系…", state: 0, data: [
                            "我嘛，我最喜欢的是战略性伙伴那个方案，真让人眼前一亮！"
                        ]
                    }];
        }
        else if (this.episode == 1) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 71000, title: "几个方案中，我比较看好其中两个…", state: 0, data: [
                            "几个方案中，我更看好打造酒店“走心”服务和重塑空间概念，这两个方案挺不错的。"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 71001, title: "我把方案放到公众号上去让网友投票了，结果…", state: 0, data: [
                            "我把你的方案隐去细节和酒店名字放到我的公众号上去让网友投票，你想不想看看哪个得分最高？",
                            "从后台统计数据来看，粉丝投票最高的是人文养生主题类型的酒店服务，还有就是提供“走心”的服务。"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 71002, title: "我喜欢机器人的方案，智能化本身就…", state: 0, data: [
                            "就个人而言，我喜欢机器人的方案，智能化本身就有着超越标准的意味，APP的概念也很有创意。",
                            "还有，安全性对于我们酒店来说也很重要，千万不能在这上面出岔子！"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 71003, title: "我觉得领导您提出的“走心”服务很打动我，再来…", state: 0, data: [
                            "方案上我觉得领导您提出的“走心”服务很打动我。再来的话，我觉得安全性是不能妥协的，这点我和小季都有相同的看法。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 71004, title: "我喜欢机器人的这个想法，当然我也赞成…", state: 0, data: [
                            "我嘛，智能机器人这个主意还是我出的呢，当然最喜欢它啦。",
                            "当然，开几个新的酒店餐饮品牌，我也很赞成，在吃货眼里绝对是食物比天大，哈哈！"
                        ]
                    }];
        }
        else if (this.episode == 2) {
            diglogues[0].count = 1;
            diglogues[0].List =
                [{
                        id: 72000, title: "这几个方案里面，我觉得你可以先…", state: 0, data: [
                            "这几个方案里面，我觉得你可以先……唔，找黎启谈谈。另外，团队激励也是个好办法。如果黎启非要现在走，那你也不妨拿出培训协议给他看。"
                        ]
                    }];
            diglogues[1].count = 1;
            diglogues[1].List =
                [{
                        id: 72001, title: "唔，要我选的话…", state: 0, data: [
                            "唔，要我选的话，肯定让他走人咯。至于人手不够，那就告诉他还有培训协议在身，短期内是走不了的。"
                        ]
                    }];
            diglogues[2].count = 1;
            diglogues[2].List =
                [{
                        id: 72002, title: "领导，我觉得应该…", state: 0, data: [
                            "领导，我觉得应该多了解下属，就算不是为了绩效问题，多听听年轻人的想法也是好的。",
                            "我觉得团队激励也很重要，多劳多得、奖惩分明，这样大家干起活来才更有积极性啊。"
                        ]
                    }];
            diglogues[3].count = 1;
            diglogues[3].List =
                [{
                        id: 72003, title: "您问我要怎么解决吗…", state: 0, data: [
                            "你问我要怎么解决吗？嗯，团队激励挺好的，接下来这么忙，额外激励一定对提高团队业绩有帮助。",
                            "至于黎启，我同意要跟他沟通一下，这孩子不错的，就这么放他走了，挺可惜的。"
                        ]
                    }];
            diglogues[4].count = 1;
            diglogues[4].List =
                [{
                        id: 72004, title: "如果你问我的意见，我觉得…", state: 0, data: [
                            "如果你问我的意见，我觉得还是涨点工资吧。什么压力大、有情绪，工资一涨就没事了。",
                            "实在不行就祭出培训协议咯，白纸黑字在那里，不想留也得留。"
                        ]
                    }];
        }
        return diglogues;
    };
    return solutionScript;
}());
export { solutionScript };



// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/solutionScript.ts.pre-build-optimizer.js